//npm run build --configuration=staging
export const environment = Object.freeze({
  production: false,
  apiURL:
    "https://knykmn46z6uc4d5ax3ywzu7ani0mbghz.lambda-url.ap-south-1.on.aws/",
  gateWayUrl: "https://gatewaystaging.devinfinitylearn.in",
  commService: "https://comservice.devinfinitylearn.in",
  enableCaptachaIntegration: true,
  captchaSiteKey:'6LfSKrorAAAAALgCIJWzbndUFUSsQmv_A32b1j5w',
  evaluatorWorkflowTemplateId: '879f4653-e1f2-4145-b6d1-7af4c296b1ec',
  evaluatorWorkflowStateId: 'a7981dc8-c256-43a7-b0ce-5ba7b3d1622a',
  ROLE_IDS: {
    ADMIN: 54,
    EVALUATOR: 55,
  },
  EVALUATION_WORKFLOW_TEMPLATE_ID:"ffd018aa-52f2-4e30-a3f4-0a78711813de"
});
